import Vue from 'vue'
import Vuex from 'vuex'
import UserAccount from './userAccount/index.js'

Vue.use(Vuex)

const state = {
    userInfo: {},
    UserAccount,
    // RealtimeGame,
    ptDatas: {
        ballMains: [], // 全投球情報
        ball1Filter: [], // フィルターされた投球1
        ball2Filter: [], // フィルターされた投球2,
        pt2Info: {},
        ballAvgSpeed: null
    },
    deviceOrientation: 'portrait',
    devicePlatform: 'other',
    deviceType: 'other',
    resizeObservation: 0,
    invalidScroll: false, // スクロールさせない指定の有無（主にモーダル時の背景固定）
    smoothScroll: false, // スクロールさせる画面でスクロールをスムーズにする指定の有無
    default: {
        UserAccount: Object.assign({}, UserAccount),
        // RealtimeGame: Object.assign({}, RealtimeGame)
    },
    listOfStadiums: [],
    video: null,
    battingVideo: null,
    toolTip: null,
    globalPitcherData: null,
    globalComparisonPitcherData:null,
    listOfTeams: {}
}

const actions = {
    setTeamsList({state, commit}, {data}) {
        commit('setTeamsList', data)
    },
    setGlobalPitcherData({state, commit}, {data}) {
        commit('setGlobalPitcherData', data)
    },
    setGlobalComparisonPitcherData({state, commit}, {data}) {
        commit('setGlobalComparisonPitcherData', data)
    },
    setToolTip({state, commit}, {data}) {
        commit('setToolTip', data)
    },
    setVideo({state, commit}, {video}) {
        commit('setVideo', video)
    },
    setBattingVideo({state, commit}, {video}) {
        commit('setBattingVideo', video)
    },
    setStadiums({state, commit}, {data}) {
        commit('setStadiums', data)
    },
    /* ユーザーアカウント関連 */
    setUserAccount({state, commit}, {data}) {
        commit('setUserAccount', data)
    },

    // /* リアルタイム試合関連 */
    // setRealtimeGameGameInfo({state, commit}, {data}) {
    //     commit('setRealtimeGameGameInfo', data)
    // },
    // setRealtimeGameCurrentGameInfo({state, commit}, {data}) {
    //     commit('setRealtimeGameCurrentGameInfo', data)
    // },

    /* 3D軌跡 ピッチトンネル関連 */
    setPtDatasBallMains({state, commit}, {data}) {
        commit('setPtDatasBallMains', data)
    },
    setPtDatasBall1Filter({state, commit}, {data}) {
        commit('setPtDatasBall1Filter', data)
    },
    setPtDatasBall2Filter({state, commit}, {data}) {
        commit('setPtDatasBall2Filter', data)
    },
    setPtDatasPt2Info({state, commit}, {data}) {
        commit('setPtDatasPt2Info', data)
    },
    setPtDatasBallAvgSpeed({state, commit}, {data}) {
        commit('setPtDatasBallAvgSpeed', data)
    },
    resetPtDatasBallAvgSpeed({state, commit}, {data}) {
        commit('resetPtDatasBallAvgSpeed', data)
    },

    /* スマホ表示関連 */
    // orientation
    changeOrientation({state, commit}, {rotate}) {
        commit('changeOrientation', rotate)
    },
    // platform
    changePlatform({state, commit}, {platform}) {
        commit('changePlatform', platform)
    },
    // Invalid Scroll
    changeInvalidScroll({state, commit}, {flg}) {
        commit('changeInvalidScroll', flg)
    },
    // Smooth Scroll
    changeSmoothScroll({state, commit}, {flg}) {
        commit('changeSmoothScroll', flg)
    }
}

const mutations = {
    setTeamsList(state, payload) {
        state.listOfTeams = payload
    },
    setGlobalPitcherData(state, payload) {
        state.globalPitcherData = payload
    },
    setGlobalComparisonPitcherData(state, payload) {
        state.globalComparisonPitcherData = payload
    },
    setToolTip(state, payload) {
        state.toolTip = payload
    },
    setVideo(state, payload) {
        state.video = payload
    },
    setBattingVideo(state, payload) {
        state.battingVideo = payload
    },
    setStadiums(state, payload) {
        state.listOfStadiums = payload
    },
    /* ユーザーアカウント関連 */
    setUserAccount(state, payload) {
        Object.assign(state.UserAccount, payload)
        if (payload.additional) {
            state.UserAccount.myTeam = payload.additional.my_team
            state.UserAccount.my_team = payload.additional.my_team
        }
    },

    /* 3D軌跡 ピッチトンネル関連 */
    setPtDatasBallMains(state, payload) {
        state.ptDatas.ballMains = payload
    },
    setPtDatasBall1Filter(state, payload) {
        state.ptDatas.ball1Filter = payload
    },
    setPtDatasBall2Filter(state, payload) {
        state.ptDatas.ball2Filter = payload
    },
    setPtDatasPt2Info(state, payload) {
        state.ptDatas.pt2Info = payload
    },
    setPtDatasBallAvgSpeed(state, payload) {
        state.ptDatas.ballAvgSpeed = payload
    },
    resetPtDatasBallAvgSpeed(state, payload) {
        state.ptDatas.ballAvgSpeed = null
    },

    /* スマホ表示関連 */
    // orientation
    changeOrientation(state, payload) {
        state.deviceOrientation = payload
        state.resizeObservation++
    },
    // platform
    changePlatform(state, payload) {
        state.devicePlatform = payload
        if (payload === 'iPhone' || payload === 'Android') {
            state.deviceType = 'smartphone'
        } else if (payload === 'iPad') {
            state.deviceType = 'tablet'
        } else {
            state.deviceType = 'other'
        }
    },
    // changeInvalidScroll
    changeInvalidScroll(state, payload) {
        state.invalidScroll = payload
    },
    // changeSmoothScroll
    changeSmoothScroll(state, payload) {
        state.smoothScroll = payload
    }
}

const getters = {
    globalPitcherData: state => state.globalPitcherData,
    globalComparisonPitcherData: state => state.globalComparisonPitcherData,
    video: state => state.video,
    battingVideo: state => state.battingVideo,
    userAccount: state => state.UserAccount,
    // realtimeGame: state => state.RealtimeGame,
    ptDatas: state => state.ptDatas,
    deviceOrientation: state => state.deviceOrientation,
    devicePlatform: state => state.devicePlatform,
    deviceType: state => state.deviceType,
    resizeObservation: state => state.resizeObservation,
    invalidScroll: state => state.invalidScroll,
    smoothScroll: state => state.smoothScroll,
    listOfStadiums: state => state.listOfStadiums,
    toolTip: state => state.toolTip,
    listOfTeams: state => state.listOfTeams
}

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
